<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="#FBB040" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template>
      <v-form ref="form" v-model="valid" lazy-validation>
        <p class="text-xl font-medium">1. Thông tin chung</p>
        <v-row class="mt-0">
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="phone"
              :rules="[rules.required]"
              outlined
              prepend-inner-icon="mdi-phone"
              color="#FBB040"
              label="Số điện thoại*"
              @keypress="filter(event)"
              :maxLength="10"
              :hide-details="isMobile"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="email"
              :rules="[rules.email]"
              outlined
              prepend-inner-icon="mdi-email"
              color="#FBB040"
              label="Email"
              :hide-details="isMobile"
            />
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="name"
              :rules="[rules.required]"
              outlined
              prepend-inner-icon="mdi-face-man"
              color="#FBB040"
              label="Họ và tên*"
              :hide-details="isMobile"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <BirthdayPicker v-model="dateOfBirth" />
          </v-col>
          <v-col>
            <v-radio-group v-model="gender" row>
              <v-radio label="Nam" :value="1" color="#FBB040" />
              <v-radio label="Nữ" :value="2" color="#FBB040" />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="password"
              :rules="[rules.required]"
              outlined
              prepend-inner-icon="mdi-form-textbox-password"
              color="#FBB040"
              label="Mật khẩu*"
              :hide-details="isMobile"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <v-select
              v-model="roleId"
              :items="roleList"
              prepend-inner-icon="mdi-roller-shade"
              no-data-text="Không có dữ liệu"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
              outlined
              color="#FBB040"
              label="Chức vụ*"
              :hide-details="isMobile"
            />
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="address"
              outlined
              :rules="[rules.required]"
              prepend-inner-icon="mdi-home-city-outline"
              color="#FBB040"
              label="Địa chỉ*"
            />
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="googleMapURL"
              outlined
              prepend-inner-icon="mdi-map-marker-check"
              color="#FBB040"
              label="Bản đồ"
            />
          </v-col>
        </v-row>
        <p class="text-xl font-medium">2. Thông tin bổ sung</p>
        <v-expansion-panels multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>Thêm thông tin</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="mt-0">
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="facebook"
                    outlined
                    color="#FBB040"
                    prepend-inner-icon="mdi-facebook"
                    label="Facebook"
                    :hide-details="isMobile"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-0">
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="zalo"
                    outlined
                    color="#FBB040"
                    prepend-inner-icon="mdi-alpha-z-circle-outline"
                    label="Zalo"
                    :hide-details="isMobile"
                  />
                </v-col>
              </v-row>
              <v-row class="mt-0">
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="description"
                    outlined
                    prepend-inner-icon="mdi-notebook"
                    color="#FBB040"
                    label="Ghi chú"
                    :hide-details="isMobile"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="mt-3">
          <v-col cols="12" sm="auto">
            <v-btn
              min-width="180"
              width="100%"
              x-large
              color="success"
              class="text-white"
              button
              dark
              @click="onCreate"
              ><v-icon right dark class="mr-2"> mdi-folder-plus </v-icon>
              Tạo mới
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </v-container>
</template>

<script>
import BirthdayPicker from "~/components/atoms/BirthdayPicker";
import { mapState } from "vuex";
import { EMPTY } from "~/utils/constants";
import { required, email } from "~/utils/validation";

export default {
  name: "CreateUser",
  components: { BirthdayPicker },
  data() {
    return {
      rules: {
        required,
        email,
      },
      phone: EMPTY,
      email: null,
      name: null,
      dateOfBirth: null,
      gender: 1,
      address: null,
      password: null,
      googleMapURL: null,
      roleId: 101,
      roleList: [],
      facebook: null,
      zalo: null,
      description: null,
      valid: true,
      isLoadingActions: false,
      valid: true,
    };
  },
  async created() {
    await this.getListMasterRole();
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 640;
    },
  },
  methods: {
    assignObject(resource, destination) {
      Object.keys(resource).forEach((key) => {
        if (destination[key] !== undefined) {
          destination[key] = resource[key];
        }
      });
    },
    async onChangeProvince() {
      this.districtList = await this.$services.patientService.getDistrictByProvince(
        this.provinceId
      );
      this.districtId = null;
      this.wardId = null;
    },
    async onChangeDistrict() {
      this.wardList = await this.$services.patientService.getWardByDistrict(
        this.districtId
      );
    },
    async onCreate() {
      this.isLoadingActions = true;
      try {
        await this.$refs.form.validate();
        if (this.valid) {
          await this.$services.userService.createUser({
            phone: this.phone,
            email: this.email,
            password: this.password,
            gender: this.gender,
            roleId: this.roleId,
            name: this.name,
            dateOfBirth: this.dateOfBirth,
            address: this.address,
            facebookUrl: this.facebook,
            zaloUrl: this.zalo,
            description: this.description,
            googleMapUrl: this.googleMapURL,
          });
          this.$router.push({ name: "UserList" });
        }
      } catch {
      } finally {
        this.isLoadingActions = false;
      }
    },
    async getListMasterRole() {
      try {
        const data = await this.$services.commonService.getListMasterRole();
        this.roleList = data;
      } catch (err) {
      } finally {
      }
    },
    filter(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>
